export const LSKeyAccessToken = 'access_token'
export const LSKeyRefreshToken = 'refresh_token'
export const LSKeyAccessTokenExp = 'access_token_exp'

export const LSKeyHeader = 'isOpenHeader'

export const LSKeyTerminalLayout = 'terminal_layout'
export const LSKeyGridLayout = 'grid_layout'
export const LSKeyFloatingLayout = 'floating_layout'
export const LSKeyGlueLayout = 'glue_layout'
export const LSKeyArhimedLayout = 'arhimed_layout'
export const LSKeyLastAccount = 'last_accounts'
